import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1b9095e2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row justify-content-center mxa-download-detail-row" }
const _hoisted_2 = { class: "col-12 col-md-3" }
const _hoisted_3 = {
  class: "mxa-download-detail-row-title",
  "data-test": "detail_label"
}
const _hoisted_4 = { class: "col-12 col-md-9" }
const _hoisted_5 = ["title"]

import * as filesize from '@/model/util/file/fileUtil'
import * as log from '@/model/util/log/Logger'


export default /*#__PURE__*/_defineComponent({
  __name: 'DownLoadDetailDispBase',
  props: {
  // 項目名
  itemLabel: {
    type: String,
    default: '',
  },
  // 項目値
  itemValue: {
    type: String,
    default: '',
  },
  // ファイルサイズかどうか
  isFilesize: {
    type: Boolean,
    default: false,
  },
},
  setup(__props) {

const props = __props

log.trace(`DownLoadDetailDispBase setup start.`)

const filesizeByteDisp = filesize.convertByteDisp
const filesizeDisp = filesize.convertDisp

// プロパティ定義

// 計算した項目値
const valueData = props.isFilesize ? filesizeDisp(Number(props.itemValue)) : props.itemValue
// 計算した項目値ラベル
const valueLabel = props.isFilesize ? filesizeByteDisp(Number(props.itemValue)) : props.itemValue
// 項目値に設定するclass名 空の場合はheightのみ設定する。
const getClass = valueData ? 'mxa-download-detail-row-body' : 'mxa-download-detail-row-nobody'

log.trace(`DownLoadDetailDispBase setup end.`)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(props.itemLabel), 1)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", {
        title: _unref(valueLabel),
        class: _normalizeClass(_unref(getClass)),
        "data-test": "detail_value"
      }, _toDisplayString(_unref(valueData)), 11, _hoisted_5)
    ])
  ]))
}
}

})